import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, inject, ViewChild, ElementRef, PLATFORM_ID } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { GlobalMessageService, GlobalMessageType, TranslationService } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { CustomerIdService } from 'src/app/services/feature/customerId/customer-id.service';
import { KbDataExtractionRequestService } from 'src/app/services/feature/data-extraction-request/kb-data-extraction-request.service';
const DATA_EXTRACTION_SUCCESS_MESSAGE = 'dataExtractionRquest.DATA_EXTRACTION_SUCCESS_MESSAGE';
import { isPlatformBrowser, ViewportScroller } from '@angular/common';
@Component({
  selector: 'app-kb-return-shipping-information',
  templateUrl: './kb-return-shipping-information.component.html',
  styleUrl: './kb-return-shipping-information.component.scss',
  standalone: false
})
export class KbReturnShippingInformationComponent {
  private dataExtractionService = inject(KbDataExtractionRequestService);
  private fb = inject(FormBuilder);
  private cdr = inject(ChangeDetectorRef);
  private datePipe = inject(DatePipe);

  private globalMessageService = inject(GlobalMessageService);
  private translationService = inject(TranslationService);
  private viewPortScroller = inject(ViewportScroller);

  allowSubmit: boolean = false;
  subscription = new Subscription();
  popupReturnShippingInformation = false;
  //captchaResolved: boolean = true;
  customerData: any;
  currentTime: string;

  @ViewChild('captchaRef', { read: ElementRef }) captchaRef!: ElementRef;
  private platformId = inject(PLATFORM_ID);
  captchaToken: string | null = null;
  captchaResolved = false;
  captchaTouched = false;
  returnShippingform = this.fb.group({
    returnShippingType: ['domestic', Validators.required],
    /*  carrier: [{ value: '', disabled: true }],
     accountNumber: [{ value: '', disabled: true }, Validators.required],
     accountPostalCode: [{ value: '', disabled: true }, Validators.required],
     accountCountryCode: [{ value: '', disabled: true }, Validators.required], */
  });

  ngOnInit(): void {
    const now = new Date();
    this.currentTime = this.datePipe.transform(now, 'dd/MM/yyyy h:mm a', 'CST');

    this.subscription.add(this.dataExtractionService.requestorData$.subscribe(customerData => {
      this.customerData = customerData;
      this.cdr.detectChanges();
    }));
    this.subscription.add(this.dataExtractionService.returnShippingFormData$
      .subscribe(returnShippingdata => {
        this.returnShippingform.patchValue(returnShippingdata);
      }));

    /*   this.subscription.add(this.returnShippingform.get('returnShippingType')?.valueChanges.subscribe(value => {
        if (value === 'international') {
          this.enableOtherFields();
          this.updateNextButtonState();
        } else {
          this.disableOtherFields();
          this.updateNextButtonState();
        }
      })); */
    this.subscription.add(
      this.returnShippingform.statusChanges.subscribe(status => {
        if (status !== 'VALID')
          this.updateNextButtonState();
      })
    );
  }
  updateNextButtonState() {
    this.allowSubmit = this.returnShippingform.valid && this.captchaResolved;
  }
  back() {
    this.dataExtractionService.currentComponent$.next('incidentInformation');
  }

  next() {
    this.captchaTouched = true;
    // Stop if captcha is not solved
    if (!this.captchaToken) {
      this.captchaResolved = false;
      this.updateNextButtonState();
      return;
    }


    this.dataExtractionService.setReturnShippingFormData(this.returnShippingform.getRawValue());
    this.subscription.add(
      this.dataExtractionService.submitOnce().subscribe({
        next: res => {

          this.globalMessageService.add(res.message, GlobalMessageType.MSG_TYPE_INFO);
          this.viewPortScroller.scrollToPosition([0, 100]);
          this.cdr.detectChanges();
        },
        error: err => {
        }
      })
    );
  }
  onCaptchaResolved(token: string | null) {
    // ng-recaptcha emits `string | null`
    this.captchaToken = token;
    this.captchaResolved = !!token;
    this.updateNextButtonState();
  }


  onCaptchaExpired() {
    this.captchaToken = null;
    this.captchaResolved = false;
    this.updateNextButtonState();
  }


  onCaptchaError() {
    this.captchaToken = null;
    this.captchaResolved = false;
    this.updateNextButtonState();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  disableOtherFields() {
    const fields = ['carrier', 'accountNumber', 'accountPostalCode', 'accountCountryCode'];
    fields.forEach(f => {
      this.returnShippingform.controls[f].patchValue('');
      this.returnShippingform.get(f)?.disable();
    });
  }

  enableOtherFields() {
    const fields = ['carrier', 'accountNumber', 'accountPostalCode', 'accountCountryCode'];
    fields.forEach(f => this.returnShippingform.get(f)?.enable());
  }
  openReturnShippingInformationpopup() {
    this.popupReturnShippingInformation = true;
  }
  closeReturnShippingInformationpopup() {
    this.popupReturnShippingInformation = false;
  }
  checkCaptcha(captchaResponse: any) {
    this.captchaResolved = captchaResponse && captchaResponse.length > 0 ? true : false;
    this.updateNextButtonState();
  }
  ngAfterViewInit(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const interval = setInterval(() => {
      window.scrollTo(0, 0);
    }, 100);

    setTimeout(() => clearInterval(interval), 3000);
  }
}


